import { createPaginatedNetworkRequestHook } from '@/utils/createPaginatedNetworkRequestHook'

import { UserId } from '@/lib/core/interfaces/user.types'

import {
  Colleague,
  OrganizationColleaguesPayload,
  PatchMyAccountPayload,
  PatchMyAccountResponse,
  SinglePatchShareContactResponse,
} from '@/lib/features/Account/interfaces'

import { useNetworkMutation } from '@/lib/utils/request'

export const useMyColleagues = createPaginatedNetworkRequestHook<Colleague>(
  'v1/organizations/colleagues/my/',
)

export const useOrganizationColleagues = createPaginatedNetworkRequestHook<
  Colleague,
  OrganizationColleaguesPayload
>('v1/organizations/${params.organizationId}/colleagues/contactable/')

export const usePatchShareContact = () => {
  return useNetworkMutation<
    SinglePatchShareContactResponse,
    {
      params: {
        id: UserId

        organizationId: number
      }
      data: { shareContact: boolean }
    }
  >({
    url: '/v1/organizations/${params.organizationId}/colleagues/contactable/${params.id}/',
    method: 'patch',
  })
}

export const usePatchMyAccount = () => {
  return useNetworkMutation<PatchMyAccountResponse, PatchMyAccountPayload>({
    url: '/v1/auth/users/me/',
    method: 'patch',
  })
}
